import Axios from "../../axios"

// 個人ごとの値
const defaultState = {
    dashBoards: [
        {
            "dashBoardId": "default",
            "dashBoardName": "デフォルトのダッシュボード",
            "dashBoardOrder": "0",
            "dashBoardLayout": [
                { "x": 0, "y": 0, "w": 2, "h": 2, "i": "1-0", "graphType": "documentFrequency", "graphTitle": "書類の利用状況", "graphDescription": "書類の利用状況のグラフです。" },
                { "x": 2, "y": 0, "w": 3, "h": 3, "i": "1-1", "graphType": "approvalTimeAverage", "graphTitle": "社員別の平均承認時間", "graphDescription": "各社員が承認するまでにかかっている平均時間のグラフです。" },
                { "x": 5, "y": 0, "w": 3, "h": 3, "i": "1-2", "graphType": "userRejectionRate", "graphTitle": "社員別申請データの却下率", "graphDescription": "各社員の申請データ却下率のグラフです。" }
            ]
        },
        {
            "dashBoardId": "dashboard2",
            "dashBoardName": "ダッシュボード2",
            "dashBoardOrdr": "2",
            "dashBoardLayout": [
                { "x": 0, "y": 0, "w": 2, "h": 2, "i": "1-3", "graphType": "deviceFrequency", "graphTitle": "デバイスの利用状況", "graphDescription": "デバイスの利用状況のグラフです。" }
            ]
        }
    ],
    selectedDashBoard: "default",
    indivisualInfo: { "not_show_tutorial": false }
}

const getters = {
    dashBoards: state => state.dashBoards,
    selectedDashBoard: state => state.selectedDashBoard,
    indivisualInfo: state => state.indivisualInfo
}

const actions = {
    SET_DASHBOARD({ commit }, argument) {
        commit('SET_DASHBOARD', argument)
    },
    SET_SELECTED_DASHBOARD({ commit }, argument) {
        commit('SET_SELECTED_DASHBOARD', argument)
    },
    GET_OWN_INFO({ commit }) {
        return Axios
            .get("/users/own")
            .then(res => {
                const data = res.data;
                commit('SET_DASHBOARD_LIST', { data })
                commit('SET_INDIVISUAL_INFO', { data })
                commit('SORT_DASHBOARD')
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error)
            });
    },
    SORT_DASHBOARD({ commit }) {
        commit('SORT_DASHBOARD')
    },
    SWITCH_NOT_SHOW_TUTORIAL({ commit }) {
        commit('SWITCH_NOT_SHOW_TUTORIAL')
    },
    STATE_INIT({ commit }) {
        commit('STATE_INIT');
    }
}

const mutations = {
    SET_DASHBOARD(state, argument) {
        var editingDashBoard = argument.editingDashBoard
        var operation = argument.operation

        var dashBoardIndex = -1;
        for (var i = 0; i < state.dashBoards.length; i++) {
            if (state.dashBoards[i].dashBoardId === editingDashBoard.dashBoardId) {
                dashBoardIndex = i;
                break;
            }
        }
        if (operation === 'deleteDashBoard') {
            if ((state.dashBoards).length > 1) {
                state.dashBoards.splice(dashBoardIndex, 1)
                state.selectedDashBoard = state.dashBoards[0].dashBoardId
                return
            } else {
                alert('1個以下にはできませんので削除しません')
            }
        }
        if (dashBoardIndex === -1) {
            // 新規作成
            state.dashBoards.push(editingDashBoard)
        } else {
            // 編集
            state.dashBoards[dashBoardIndex] = editingDashBoard
        }
        mutations.SORT_DASHBOARD(state)
        // 選択中のダッシュボードを保存したダッシュボードに切り替える
        state.selectedDashBoard = editingDashBoard.dashBoardId
    },
    SET_SELECTED_DASHBOARD(state, newSelectedDashBoard) {
        state.selectedDashBoard = newSelectedDashBoard
    },
    SET_DASHBOARD_LIST(state, { data }) {
        state.dashBoards = data.dashboards;
    },
    SET_INDIVISUAL_INFO(state, { data }) {
        state.indivisualInfo = data.indivisual_info;
    },
    SORT_DASHBOARD(state) {
        // dashBoardOrderの値でソート
        state.dashBoards.sort(function (a, b) {
            if (a.dashBoardOrder > b.dashBoardOrder) {
                return 1;
            } else {
                return -1;
            }
        })
    },
    SWITCH_NOT_SHOW_TUTORIAL(state) {
        state.indivisualInfo.not_show_tutorial = !state.indivisualInfo.not_show_tutorial
    },
    STATE_INIT(state) {
        Object.assign(state, defaultState)
    }
}

export default {
    namespaced: true,
    state: JSON.parse(JSON.stringify(defaultState)),
    getters,
    actions,
    mutations
}
